export function setMeta({ title, description, url, image, type = 'website' } = {}) {
  if (title) {
    document.title = title;
  }

  function upsertMeta(name, content, attr = 'name') {
    if (!content) return;
    let meta = document.querySelector(`meta[${attr}="${name}"]`);
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attr, name);
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', content);
  }

  upsertMeta('description', description);
  upsertMeta('og:title', title, 'property');
  upsertMeta('og:description', description, 'property');
  upsertMeta('og:type', type, 'property');
  upsertMeta('og:url', url, 'property');
  upsertMeta('og:image', image, 'property');
  upsertMeta('twitter:card', image ? 'summary_large_image' : 'summary');
  upsertMeta('twitter:title', title);
  upsertMeta('twitter:description', description);
  upsertMeta('twitter:image', image);

  // canonical link
  if (url) {
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = url;
  }
}

/* Upsert a JSON-LD block by id. Returns a cleanup function that removes it,
   so route components don't leave their schema behind on other pages. */
export function setJsonLd(id, data) {
  const scriptId = `jsonld-${id}`;
  let script = document.getElementById(scriptId);
  if (!script) {
    script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = scriptId;
    document.head.appendChild(script);
  }
  script.text = JSON.stringify(data);
  return () => {
    const el = document.getElementById(scriptId);
    if (el) el.remove();
  };
}

export const SITE_URL = 'https://documore.com';

export function breadcrumbJsonLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function faqJsonLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function injectOrganizationJsonLd({ name, url, logo, sameAs = [] }) {
  const scriptId = 'jsonld-organization';
  let script = document.getElementById(scriptId);
  if (script) script.remove();

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name,
    url,
    logo,
    sameAs,
  };

  script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = scriptId;
  script.text = JSON.stringify(jsonLd);
  document.head.appendChild(script);
}
